import { render, staticRenderFns } from "./controleSlackBot.vue?vue&type=template&id=687ee486&"
import script from "./controleSlackBot.vue?vue&type=script&lang=js&"
export * from "./controleSlackBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports